import currentPricingRequestObj from './currentPricingRequestObj'

// Increment store count
export const INCREMENT = function(state) { 
  state.count++
}

/* Set App Config Data */
export const SET_APP_CONFIG = function(state, data) {
  state.plans = data.plans
}

/* Set User */
export const SET_USER = function(state, data) {
  state.auth = data
}

/* Set User Preferences */
export const SET_USER_PREFERENCES = function(state, data) {
  state.auth.user.preferences = data
}

/* Set Registered */
export const SET_REGISTERED = function(state, data) {
  state.registered = true
}

/* Set User Branding Settings */
export const SET_USER_BRANDING = function(state, data) {
  state.userBranding = data
}

/* Set Dashboard View */
export const SET_VIEW_DASHBOARD = function(state) {
  state.view = 'dashboard'
}

/* Set Workspace View */
export const SET_VIEW_WORKSPACE = function(state) {
  state.view = 'workspace'
}

/* Set Notification Message */
export const SET_NOTIFICATION = function(state, data) {
  state.notification = {
    type: data.type,
    title: data.title,
    msg: data.msg
  }
}

/* Clear Notification Message */
export const CLEAR_NOTIFICATION = function(state) {
  state.notification = {
    type: '',
    msg: ''
  }
}

/* Set Plan-Specific Configuration */
export const SET_PLAN_CONFIG = function(state, data) {
  state.planConfig = data
}

/* Clear Current Pricing Request */
export const CLEAR_CURRENT_PRICING_REQUEST = function(state) {
  state.currentPricingRequest = Object.assign({}, currentPricingRequestObj)
  state.declineBrokerFee = false
}

/* Set Saved Pricing Request ID */
export const SET_SAVED_PRICING_REQUEST_ID = function(state, id) {  
  state.currentPricingRequest.savedPricingRequestId = id
}

/* Clear Saved Pricing Request ID */
export const CLEAR_SAVED_PRICING_REQUEST_ID = function(state) {  
  state.currentPricingRequest.savedPricingRequestId = ''
}

/* Set Utility */
export const SET_UTILITY = function(state, utilityData) { 
  state.currentPricingRequest.utilityMeta = {
    id: utilityData.id,
    code: utilityData.code,
    name: utilityData.name,
    state: utilityData.state,
    municipality: utilityData.municipality,
    zone: utilityData.zone,
    displayBrokerFee: utilityData.displayBrokerFee
  }

  // Keeping plan-related data separate b/c this object is replaced when saved inputs are retrieved
  state.currentPricingRequest.utility = { 
    id: utilityData.planData.id,
    name: utilityData.planData.name,
    plan: {
      name: utilityData.planData.plan.name,
      slug: utilityData.planData.plan.slug
    }
  }
}

/* Set Utility Custom Facility Profile Columns */
export const SET_CUSTOM_FACILITY_PROFILE_COLUMNS = function(state, data) { 
  state.customFacilityProfileColumns = data
}

/* Clear Utility Custom Facility Profile Columns */
export const CLEAR_CUSTOM_FACILITY_PROFILE_COLUMNS = function(state) { 
  state.customFacilityProfileColumns = {}
}

/* Set Facility Profiles */
export const SET_FACILITY_PROFILES = function(state, data) { 
  state.facilityProfiles = data
}

/* Clear Facility Profiles */
export const CLEAR_FACILITY_PROFILES = function(state) { 
  state.currentFacilityCategory = {}
  state.facilityProfiles = {}
  state.facilityProfilesUtilityId = null
}

/**
 * Set Facility Profiles Utility ID
 * 
 * This is used to track the which utility we've loaded the facility 
 * profiles for, so that we don't do another unnecessary roundtrip
 * to the server to load them if they're already loaded.
 */
export const SET_FACILITY_PROFILES_UTILITY_ID = function(state, id) { 
  state.facilityProfilesUtilityId = id
}

/* Set Facility Category */
export const SET_FACILITY_CATEGORY = function(state, data) {
  state.currentFacilityCategory = {
    id: data.id,
    name: data.name,
    thumb: data.thumb,
    parents: data.parents,
    options: data.options,
    twoColumns: data.twoColumns,
    checkboxOptions: data.checkboxOptions
  }
}

/* Clear Facility Category */
export const CLEAR_FACILITY_CATEGORY = function(state) { 
  state.currentFacilityCategory = {}
}

/* Set Inline Facility Path */
export const SET_INLINE_FACILITY_PATH = function(state, path) { 
  state.inlineFacilityPath = path
}

/* Clear Inline Facility Path */
export const CLEAR_INLINE_FACILITY_PATH = function(state) { 
  state.inlineFacilityPath = []
}

/* Set Facility Type */
export const SET_FACILITY_TYPE = function(state, data) { 
  state.currentPricingRequest.facilityType = {
    id: data.id,
    name: data.name,
    category: data.category,
    parents: data.parents,
    displayName: data.displayName
  }
}

/* Clear Facility Type */
export const CLEAR_FACILITY_TYPE = function(state) { 
  state.currentPricingRequest.facilityType = {}
}

/* Set User-Defined Facility Profile Name */
export const SET_FACILITY_PROFILE_NAME = function(state, data) { 
  state.currentPricingRequest.facilityProfileName = data
}

/* Clear User-Defined Facility Profile Name */
export const CLEAR_FACILITY_PROFILE_NAME = function(state) { 
  state.currentPricingRequest.facilityProfileName = ''
}

/* Set User-Defined Facility Profile Category */
export const SET_CUSTOM_FACILITY_PROFILE_CATEGORY = function(state, data) { 
  state.currentPricingRequest.customFacilityProfileCategory = data
}

/* Set User-Defined Facility Profile Category Data */
export const SET_CUSTOM_FACILITY_PROFILE_CATEGORY_DATA = function(state, data) { 
  state.currentPricingRequest.customFacilityProfileCategory.data = data
}

/* Clear User-Defined Facility Profile Category */
export const CLEAR_CUSTOM_FACILITY_PROFILE_CATEGORY = function(state) { 
  state.currentPricingRequest.customFacilityProfileCategory = {}
}

/* Set Facility Checkbox Selections */
export const SET_FACILITY_CHECKBOX_SELECTIONS = function(state, data) { 
  state.currentPricingRequest.facilityCheckboxSelections = data
}

/* Clear Facility Checkbox Selections */
export const CLEAR_FACILITY_CHECKBOX_SELECTIONS = function(state) { 
  state.currentPricingRequest.facilityCheckboxSelections = {}
}

/* Set Custom Facility Profile */
export const SET_CUSTOM_FACILITY_PROFILE = function(state, data) { 
  state.currentPricingRequest.customFacilityProfile = data
}

/* Clear Custom Facility Profile */
export const CLEAR_CUSTOM_FACILITY_PROFILE = function(state, data) { 
  state.currentPricingRequest.customFacilityProfile = {}
}

/* Set Temporary Custom Facility Profile */
export const SET_TEMP_CUSTOM_FACILITY_PROFILE = function(state, data) { 
  state.tempCustomFacilityProfile = data
}

/* Clear Temporary Custom Facility Profile */
export const CLEAR_TEMP_CUSTOM_FACILITY_PROFILE = function(state) { 
  state.tempCustomFacilityProfile = {}
}

/* Set the Current Custom Facility Profile UI Step/View */
export const SET_CUSTOM_FACILITY_PROFILE_UI_STEP = function(state, step) { 
  state.customFacilityProfileUiStep = step
}

/* Set the Current Custom Facility Profile UI On-Peak Percent Choice */
export const SET_CUSTOM_FACILITY_PROFILE_UI_ON_PEAK_USAGE_PERCENT_CHOICE = function(state, value) { 
  state.currentPricingRequest.enterCustomFacilityProfileOnPeakUsageAsPercentage = value
}

/* Set the Current Custom Facility Profile UI Repeat Monthly Values Choice */
export const SET_CUSTOM_FACILITY_PROFILE_UI_REPEAT_MONTHLY_VALUES = function(state, value) { 
  state.currentPricingRequest.setCustomFacilityProfileUiRepeatMonthlyValues = value
}

/* Set that the user has changed a default Current Custom Facility Profile On-Peak Usage (%) value  */
export const SET_USER_HAS_CHANGED_A_CUSTOM_FACILITY_PROFILE_ON_PEAK_USAGE_PERCENT_VALUE = function(state, value) { 
  state.currentPricingRequest.userHasChangedACustomFacilityProfilOnPeakUsagePercentValue = value
}

/* Set Custom Facility Profile View */
export const SET_CUSTOM_FACILITY_PROFILE_VIEW = function(state) { 
  state.customFacilityProfileView = true
}

/* Unset Custom Facility Profile View */
export const UNSET_CUSTOM_FACILITY_PROFILE_VIEW = function(state) { 
  state.customFacilityProfileView = false
}

/* Collapse Custom Facility Profile Table */
export const COLLAPSE_CUSTOM_FACILITY_PROFILE_TABLE = function(state) { 
  state.collapseCustomFacilityProfileTable = true
}

/* Expand Custom Facility Profile Table */
export const EXPAND_CUSTOM_FACILITY_PROFILE_TABLE = function(state) { 
  state.collapseCustomFacilityProfileTable = false
}

/* Set Start Month */
export const SET_START_MONTH = function(state, timestamp) { 
  state.currentPricingRequest.startMonth = timestamp
}

/* Clear Start Month */
export const CLEAR_START_MONTH = function(state) { 
  state.currentPricingRequest.startMonth = ''
}

/* Set Volume */
export const SET_VOLUME = function(state, data) { 
  state.currentPricingRequest.volume = {
    amount: data.amount,
    unit: data.unit,
    brokerFee: data.brokerFee,
    adjustmentNotes: data.adjustmentNotes,
    displayAdjustmentInNav: data.displayAdjustmentInNav,
  }
}

/* Clear Volume */
export const CLEAR_VOLUME = function(state) { 
  state.currentPricingRequest.volume = {
    amount: '',
    unit: 'usage',
    brokerFee: ''
  }
}

/* Set Custom Facility Volume */
export const SET_CUSTOM_FACILITY_VOLUME = function(state, data) { 
  state.currentPricingRequest.customFacilityVolume = {
    terms: data.terms,
    brokerFee: data.brokerFee,
    adjustmentNotes: data.adjustmentNotes,
    displayAdjustmentInNav: data.displayAdjustmentInNav,
  }
}

/* Clear Custom Facility Volume */
export const CLEAR_CUSTOM_FACILITY_VOLUME = function(state) { 
  state.currentPricingRequest.customFacilityVolume = {}
}

/* Set Term Length */
export const SET_TERM_LENGTH = function(state, data) {
  state.currentPricingRequest.termLength = data
}

/* Clear Term Length */
export const CLEAR_TERM_LENGTH = function(state) {
  state.currentPricingRequest.termLength = [
    {
      id: 1,
      value: ''
    },
    {
      id: 2,
      value: ''
    },
    {
      id: 3,
      value: ''
    }
  ]
}

/* Enable Pricing Request Submission */
export const ENABLE_PRICING_REQUEST_SUBMISSION = function(state) {
  state.allowPricingRequestSubmission = true
}

/* Disable Pricing Request Submission */
export const DISABLE_PRICING_REQUEST_SUBMISSION = function(state) {
  state.allowPricingRequestSubmission = false
}

/* Reset App State Broker Fee */
export const RESET_STATE_BROKER_FEE = function(state) {
  state.declineBrokerFee = false
}

/* Decline Broker Fee */
export const DECLINE_BROKER_FEE = function(state) {
  state.declineBrokerFee = true
  state.currentPricingRequest.volume.declineBrokerFee = true
  state.currentPricingRequest.customFacilityVolume.declineBrokerFee = true
}

/* Allow Broker Fee */
export const ALLOW_BROKER_FEE = function(state) {
  state.declineBrokerFee = false
  state.currentPricingRequest.volume.declineBrokerFee = false
}

/* Restrict Broker Fee */
export const RESTRICT_BROKER_FEE = function(state) {
  state.declineBrokerFee = false
  state.currentPricingRequest.volume.declineBrokerFee = false
}

/* Hover On Submit Pricing Request Button */
export const HOVER_ON_SUBMIT_PRICING_REQUEST = function(state) {
  state.submitPricingRequestHover = true
}

/* Hover Off Submit Pricing Request Button */
export const HOVER_OFF_SUBMIT_PRICING_REQUEST = function(state) {
  state.submitPricingRequestHover = false
}

/* Flag that we're loading, or not loading, the user's saved pricing requests */
export const SET_IS_LOADING_SAVED_PRICE_REQUESTS = function(state, flag) {
  state.isLoadingSavedPriceRequests = flag
}

/* Load Saved Pricing Request */
export const LOAD_SAVED_PRICING_REQUEST = function(state, pricingRequest) {
  state.currentPricingRequest = pricingRequest
}

/* Save Loaded Pricing Request */
export const SAVE_LOADED_PRICING_REQUEST = function(state, pricingRequest) {
  state.lastLoadedPricingRequest = pricingRequest
}

/* Replace Saved Pricing Request */
export const REPLACE_SAVED_PRICING_REQUESTS = function(state, pricingRequests) {
  state.savedPricingRequests = pricingRequests
}

/* Delete All Saved Pricing Requests */
export const DELETE_SAVED_PRICING_REQUESTS = function(state) {
  state.savedPricingRequests = []
}

/* Set Dashboard Sort Utility */
export const SET_DASHBOARD_SORT_UTILITY = function(state, data) {
  state.dashboardSortUtility = data
}

/* Set Pricing Request Status */
export const SET_PRICING_REQUEST_STATUS = function(state, status) {
  state.pricingRequestStatus = status
}

/* Clear Pricing Request Status */
export const CLEAR_PRICING_REQUEST_STATUS = function(state) {
  state.pricingRequestStatus = ''
}

/* Set Current Pricing Request Data */
export const SET_CURRENT_PRICING_DATA = function(state, data) {
  state.currentPricingData.data = data
}

/* Set Current Pricing Request Data Totals */
export const SET_CURRENT_PRICING_DATA_TOTALS = function(state, data) {
  state.currentPricingData.totals = data
}

/* Set Current Pricing Request ID */
export const SET_CURRENT_PRICING_DATA_REQUEST_ID = function(state, id) {
  state.currentPricingData.requestId = id
}

/* Clear Current Pricing Request Data */
export const CLEAR_CURRENT_PRICING_DATA = function(state, data) {
  state.currentPricingData = {
    data: {},
    totals: {},
    requestId: null
  }
}

/* Set Pricing Table Sort Utility */
export const SET_UTILITY_DROPDOWN_SORT = function(state, data) {
  state.utilityDropdownSort = data
}

/* Set Dashboard Pricing Components */
export const SET_DASHBOARD_PRICING_COMPONENTS = function(state, data) {
  state.dashboardPricingComponents = data
}

/* Set Primary Pricing Component In Input Set */
export const SET_PRIMARY_PRICING_COMPONENT = function(state, data) {
  state.currentPricingRequest.primaryPricingComponent = data
}

/* Toggle Pricing Table Row Expansion */
export const TOGGLE_EXPAND_PRICING_TABLE_ROWS = function(state) {
  state.expandAllPricingRows = !state.expandAllPricingRows
}

/* Expand All Pricing Table Rows */
export const EXPAND_PRICING_TABLE_ROWS = function(state) {
  state.expandAllPricingRows = true
}

/* Collapse All Pricing Table Rows */
export const COLLAPSE_PRICING_TABLE_ROWS = function(state) {
  state.expandAllPricingRows = false
}

/* Add Pricing Alert */
export const ADD_PRICING_ALERT = function(state) {
}

/* Remove Pricing Alert */
export const REMOVE_PRICING_ALERT = function(state) {
}

/* Set Current Pricing Chart Data */
export const SET_CURRENT_PRICING_CHART_DATA = function(state, data) {
  state.currentPricingChartData = data
}

/* Clear Current Pricing Chart Data */
export const CLEAR_CURRENT_PRICING_CHART_DATA = function(state) {
  state.currentPricingChartData = {}
}

/* Set the current pricing chart's locked date. */
export const SET_CURRENT_PRICING_CHART_LOCKED_DATE = function(state, date) {
  state.currentPricingChartLockedDate = date
}

/* Set Total Batch Dates */
export const SET_TOTAL_BATCH_DATES = function(state, count) {
  state.batchDatesTotal = count
}

/* Set Remaining Batch Dates */
export const SET_REMAINING_BATCH_DATES = function(state, count) {
  state.batchDatesRemaining = count
}

/* Clear Batch Dates */
export const CLEAR_BATCH_DATES = function(state) {
  state.batchDatesTotal = 0
  state.batchDatesRemaining = 0
}

/* Set Current Batch */
export const SET_CURRENT_BATCH = function(state, batch) {
  state.currentBatch = batch
}

/* Add Data Listener */
export const ADD_DATA_LISTENER = function(state, id) {
  state.activeListeners.push(id)
}

/* Remove Data Listener */
export const REMOVE_DATA_LISTENER = function(state, id) {
  state.activeListeners = state.activeListeners.filter(listener => listener != id)
}

/* Clear Data Listeners */
export const CLEAR_DATA_LISTENERS = function(state) {
  state.activeListeners = []
}

/* Set Screen/View Capture */
export const SET_VIEW_CAPTURE = function(state, dataUrl) {
  state.viewCapture = dataUrl
}

/* Add to the stored user share emails */
export const ADD_TO_USER_SHARE_EMAILS = function(state, emails) {
  // Filter out emails that already exist
  if (state.auth.shares) {
    emails = emails.filter(function(email) {
      return ! state.auth.shares.includes(email)
    })
  }
  
  if (emails) {
    if (state.auth.shares) {
      state.auth.shares = state.auth.shares.concat(emails)
    } else {
      state.auth.shares = emails
    }
  }
}

/* Remove a stored user share email */
export const REMOVE_FROM_USER_SHARE_EMAILS = function(state, email) {
  state.auth.shares = state.auth.shares.filter(function(e) {
    return e != email
  })
}

/* Accept Terms of Use */
export const ACCEPT_TERMS_OF_USE = function(state) {
  state.acceptTermsOfUse = true
}

/* Decline Terms of Use */
export const DECLINE_TERMS_OF_USE = function(state) {
  state.acceptTermsOfUse = false
}
